import MedalsService from "../api/medals"
import RecipientService from "../api/recipient"
import elasticlunr from 'elasticlunr'

import {deaccent} from '@/utils/text'

let index = elasticlunr(function () {
    this.setRef('id')
    this.addField('name')
    this.addField('year')
});

export const state = () => ({
    list: [],
    list_results: [],
    list_loaded: false,
    list_loading: false,
    item: null,
    item_loading: false,
    recipients: [],
    recipients_loading: false
})

export const getters = {
    item(state) {
        return state.item
    },
    item_loading(state) {
        return state.item_loading
    },
    list_results(state) {
        return state.list_results
    },
    list_loading(state) {
        return state.list_loading
    },
    recipients(state) {
        return state.recipients
    },
    recipients_loading(state) {
        return state.recipients_loading
    }
}

export const actions = {
    async fetch({commit, state}, params) {
        if (state.item_loading) {
            return
        }
        commit('setItemLoading', true)
        commit('setRecipientsLoading', true)

        // TODO: Add error handling (throw 404)
        let i = state.list.find(el => el.id == params.slug)
        commit('setItem', i)

        await RecipientService.medal_recipients(params.locale, MedalsService.search_token_by_id(i.id))
            .then((response) => {
                commit('setRecipients', response.data)
            })
            .catch((error) => {
                console.log(`Recipients API Error => ${error}`)
            })
    },
    async fetch_list({commit, state}, params) {
        if (state.list_loading || state.list_loaded) {
            return
        }

        commit('setListLoading', true)
        const data = MedalsService.all(params.locale)
        commit('setList', data)
    },
    async clear_search({commit, state}, params) {
        commit('resetSearch')
        return
    },
    async null_item({commit}) {
        commit('setItem', null);
        commit('setRecipients', null);
    },
    async search({commit, state}, q) {
        if(!q) {
            commit('resetSearch')
            return
        }
        commit('setSearchResults', index.search(deaccent(decodeURI(q)), {
            boolean: "OR",
            expand: true
        }))
    }
}

export const mutations = {
    resetSearch(state) {
        state.list_results = state.list
    },
    search(state, results) {
        state.list_results = results
    },
    setItem(state, item) {
        state.item = item
        state.item_loading = false
    },
    setList(state, data) {
        data.forEach(item => {
            index.addDoc({
                'id': item.id,
                'name': deaccent(item.name),
                'year': item.year,
            })
        });

        state.list = data
        state.list_results = data
        state.list_loaded = true
        state.list_loading = false
    },
    setListLoading(state, loading) {
        state.list_loading = loading
    },
    setItemLoading(state, loading) {
        state.item_loading = loading
    },
    setRecipients(state, recipients) {
        if(recipients) {
            state.recipients = "results" in recipients ? recipients.results : []
        } else {
            state.recipients = []
        }
        state.recipients_loading = false
    },
    setRecipientsLoading(state, loading) {
        state.recipients_loading = loading
    },
    setSearchResults(state, results) {
        const ids = results.map((result) => (
            parseInt(result.ref)
        ))
        state.list_results = state.list.filter((item) => (
            ids.includes(item.id)
        ))
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
